import Vue from "vue";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import { Nullable } from "@/general/custom-types/CustomTypes";

@Component
export class Page extends Vue {
  @Prop({ type: String, default: "TDS" }) headTitle: Nullable<string>;
  @Prop({ type: Array, default: () => [] }) meta: Nullable<[]>;

  head() {
    return {
      title: this.headTitle,
      meta: this.meta
    };
  }
}
